export default __webpack_public_path__ + "static/media/chiodo.d5cae46a.png";